/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  DeletedResponseDto,
  WgAbTestProposalDto,
  WgAddCommitmentsDto,
  WgAddCommitmentsResultDto,
  WgApproveBriefsDto,
  WgApproveBriefsResultDto,
  WgBriefCardDto,
  WgBriefListResponseDto,
  WgClientControllerCollectionsParams,
  WgClientControllerListBriefsParams,
  WgClientControllerListMomentsParams,
  WgClientEngagementDto,
  WgClientTasksDto,
  WgCollectionDto,
  WgComposeBriefDto,
  WgComposeOneOffBriefDto,
  WgComposeOneOffResultDto,
  WgComposeResultDto,
  WgCopySuggestionsDto,
  WgExpandBriefDto,
  WgExpandedBriefDto,
  WgFillGapsDto,
  WgFillGapsResultDto,
  WgHealthControllerHealthParams,
  WgMomentListDto,
  WgParseCommitmentsDto,
  WgParseCommitmentsResultDto,
  WgProposeAbTestDto,
  WgRewriteBriefDto,
  WgRewrittenBriefDto,
  WgScheduleProposalDto,
  WgServiceHealthDto,
  WgSuggestBriefCopyDto,
  WgUpdateBriefDto,
  WgUpdateBriefResultDto,
  WgUpdateScheduleDto,
  WgUpdateScheduleResultDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary The brand's service contract, as the customer sees it
 */
export const wgClientControllerEngagement = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgClientEngagementDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/engagement`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getWgClientControllerEngagementQueryKey = (orgId?: string, clientId?: string) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/engagement`] as const;
};

export const getWgClientControllerEngagementQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerEngagement>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerEngagement>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerEngagementQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerEngagement>>> = ({
    signal,
  }) => wgClientControllerEngagement(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerEngagement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerEngagementQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerEngagement>>
>;
export type WgClientControllerEngagementQueryError = void;

export function useWgClientControllerEngagement<
  TData = Awaited<ReturnType<typeof wgClientControllerEngagement>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerEngagement>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerEngagement>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerEngagement>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerEngagement<
  TData = Awaited<ReturnType<typeof wgClientControllerEngagement>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerEngagement>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerEngagement>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerEngagement>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerEngagement<
  TData = Awaited<ReturnType<typeof wgClientControllerEngagement>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerEngagement>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The brand's service contract, as the customer sees it
 */

export function useWgClientControllerEngagement<
  TData = Awaited<ReturnType<typeof wgClientControllerEngagement>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerEngagement>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerEngagementQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Active collections synced from the store, by title. A brief that names one gets a grid of its products as the store has them when the work is built.
 * @summary The brand's store collections, for naming one on a brief
 */
export const wgClientControllerCollections = (
  orgId: string,
  clientId: string,
  params?: WgClientControllerCollectionsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgCollectionDto[]>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/collections`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getWgClientControllerCollectionsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: WgClientControllerCollectionsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/collections`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWgClientControllerCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerCollections>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerCollections>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerCollectionsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerCollections>>> = ({
    signal,
  }) => wgClientControllerCollections(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerCollections>>
>;
export type WgClientControllerCollectionsQueryError = void;

export function useWgClientControllerCollections<
  TData = Awaited<ReturnType<typeof wgClientControllerCollections>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: undefined | WgClientControllerCollectionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerCollections>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerCollections>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerCollections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerCollections<
  TData = Awaited<ReturnType<typeof wgClientControllerCollections>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerCollections>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerCollections>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerCollections>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerCollections<
  TData = Awaited<ReturnType<typeof wgClientControllerCollections>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerCollections>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The brand's store collections, for naming one on a brief
 */

export function useWgClientControllerCollections<
  TData = Awaited<ReturnType<typeof wgClientControllerCollections>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerCollectionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerCollections>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerCollectionsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary What is waiting on whom, grouped by who holds the ball
 */
export const wgClientControllerTasks = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgClientTasksDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/tasks`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getWgClientControllerTasksQueryKey = (orgId?: string, clientId?: string) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/tasks`] as const;
};

export const getWgClientControllerTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerTasks>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerTasks>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWgClientControllerTasksQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerTasks>>> = ({
    signal,
  }) => wgClientControllerTasks(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerTasks>>
>;
export type WgClientControllerTasksQueryError = void;

export function useWgClientControllerTasks<
  TData = Awaited<ReturnType<typeof wgClientControllerTasks>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerTasks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerTasks>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerTasks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerTasks<
  TData = Awaited<ReturnType<typeof wgClientControllerTasks>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerTasks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerTasks>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerTasks>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerTasks<
  TData = Awaited<ReturnType<typeof wgClientControllerTasks>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerTasks>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What is waiting on whom, grouped by who holds the ball
 */

export function useWgClientControllerTasks<
  TData = Awaited<ReturnType<typeof wgClientControllerTasks>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerTasks>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerTasksQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Brief cards, with their production state on them
 */
export const wgClientControllerListBriefs = (
  orgId: string,
  clientId: string,
  params?: WgClientControllerListBriefsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgBriefListResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getWgClientControllerListBriefsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: WgClientControllerListBriefsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWgClientControllerListBriefsQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListBriefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListBriefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerListBriefsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerListBriefs>>> = ({
    signal,
  }) => wgClientControllerListBriefs(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerListBriefsQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerListBriefs>>
>;
export type WgClientControllerListBriefsQueryError = void;

export function useWgClientControllerListBriefs<
  TData = Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: undefined | WgClientControllerListBriefsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListBriefs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerListBriefs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerListBriefs<
  TData = Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListBriefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListBriefs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerListBriefs>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerListBriefs<
  TData = Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListBriefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListBriefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Brief cards, with their production state on them
 */

export function useWgClientControllerListBriefs<
  TData = Awaited<ReturnType<typeof wgClientControllerListBriefs>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListBriefsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListBriefs>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerListBriefsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The brief lands on the plan, its date becomes an anchor, and the ticket opens immediately. A date inside the production lead time is accepted as a rush with an explicit delivery date. With `holdForApproval` it lands pending instead, with no ticket, until it is approved.
 * @summary Save a brief the customer wrote, into production or held for later
 */
export const wgClientControllerCompose = (
  orgId: string,
  clientId: string,
  wgComposeBriefDto: WgComposeBriefDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgComposeResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgComposeBriefDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerComposeMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerCompose>>,
    TError,
    { orgId: string; clientId: string; data: WgComposeBriefDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerCompose>>,
  TError,
  { orgId: string; clientId: string; data: WgComposeBriefDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerCompose'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerCompose>>,
    { orgId: string; clientId: string; data: WgComposeBriefDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerCompose(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerComposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerCompose>>
>;
export type WgClientControllerComposeMutationBody = WgComposeBriefDto;
export type WgClientControllerComposeMutationError = void;

/**
 * @summary Save a brief the customer wrote, into production or held for later
 */
export const useWgClientControllerCompose = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerCompose>>,
      TError,
      { orgId: string; clientId: string; data: WgComposeBriefDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerCompose>>,
  TError,
  { orgId: string; clientId: string; data: WgComposeBriefDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerComposeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * What a link to a brief opens. The id is all it takes, so a brief that has been re-dated since the link was made still opens.
 * @summary One brief card, by id
 */
export const wgClientControllerGetBrief = (
  orgId: string,
  clientId: string,
  itemId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgBriefCardDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getWgClientControllerGetBriefQueryKey = (
  orgId?: string,
  clientId?: string,
  itemId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}`,
  ] as const;
};

export const getWgClientControllerGetBriefQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerGetBriefQueryKey(orgId, clientId, itemId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerGetBrief>>> = ({
    signal,
  }) => wgClientControllerGetBrief(orgId, clientId, itemId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && clientId && itemId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type WgClientControllerGetBriefQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerGetBrief>>
>;
export type WgClientControllerGetBriefQueryError = void;

export function useWgClientControllerGetBrief<
  TData = Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  itemId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerGetBrief>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerGetBrief<
  TData = Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerGetBrief>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerGetBrief<
  TData = Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary One brief card, by id
 */

export function useWgClientControllerGetBrief<
  TData = Awaited<ReturnType<typeof wgClientControllerGetBrief>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  itemId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerGetBrief>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerGetBriefQueryOptions(orgId, clientId, itemId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Removes a customer-written or nexmail-generated brief from the calendar and cancels its queued ticket. Refuses with a 400 if production has already started.
 * @summary Delete a brief before production starts
 */
export const wgClientControllerDeleteBrief = (
  orgId: string,
  clientId: string,
  itemId: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeletedResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}`,
      method: 'DELETE',
    },
    options
  );
};

export const getWgClientControllerDeleteBriefMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>,
    TError,
    { orgId: string; clientId: string; itemId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationKey = ['wgClientControllerDeleteBrief'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>,
    { orgId: string; clientId: string; itemId: string }
  > = (props) => {
    const { orgId, clientId, itemId } = props ?? {};

    return wgClientControllerDeleteBrief(orgId, clientId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerDeleteBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>
>;

export type WgClientControllerDeleteBriefMutationError = void;

/**
 * @summary Delete a brief before production starts
 */
export const useWgClientControllerDeleteBrief = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>,
      TError,
      { orgId: string; clientId: string; itemId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerDeleteBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationOptions = getWgClientControllerDeleteBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * A re-date landing inside the production lead time is refused with a 409 naming the rush and its delivery date; sending confirmRush accepts it. A design edit while the first design is in review is refused with a 409 (WG_BRIEF_EDIT_NEEDS_ROUND) naming the revision round it would open; sending requestChanges opens it. Design edits on a scheduled or finished email are refused (WG_BRIEF_LOCKED).
 * @summary Edit a brief in place, including re-dating it
 */
export const wgClientControllerUpdateBrief = (
  orgId: string,
  clientId: string,
  itemId: string,
  wgUpdateBriefDto: WgUpdateBriefDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<WgUpdateBriefResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: wgUpdateBriefDto,
    },
    options
  );
};

export const getWgClientControllerUpdateBriefMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>,
    TError,
    { orgId: string; clientId: string; itemId: string; data: WgUpdateBriefDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string; data: WgUpdateBriefDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerUpdateBrief'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>,
    { orgId: string; clientId: string; itemId: string; data: WgUpdateBriefDto }
  > = (props) => {
    const { orgId, clientId, itemId, data } = props ?? {};

    return wgClientControllerUpdateBrief(orgId, clientId, itemId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerUpdateBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>
>;
export type WgClientControllerUpdateBriefMutationBody = WgUpdateBriefDto;
export type WgClientControllerUpdateBriefMutationError = void;

/**
 * @summary Edit a brief in place, including re-dating it
 */
export const useWgClientControllerUpdateBrief = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>,
      TError,
      { orgId: string; clientId: string; itemId: string; data: WgUpdateBriefDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerUpdateBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string; data: WgUpdateBriefDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerUpdateBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Every input is optional. With a line of intent it finishes that decision; with products picked it builds the email around them; with neither it proposes the idea outright. Expansion happens in the composer so the customer always sees the brief they are committing to and edits it in place.
 * @summary Write a full brief for one date, without saving it
 */
export const wgClientControllerExpand = (
  orgId: string,
  clientId: string,
  wgExpandBriefDto: WgExpandBriefDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgExpandedBriefDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/expand`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgExpandBriefDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerExpandMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerExpand>>,
    TError,
    { orgId: string; clientId: string; data: WgExpandBriefDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerExpand>>,
  TError,
  { orgId: string; clientId: string; data: WgExpandBriefDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerExpand'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerExpand>>,
    { orgId: string; clientId: string; data: WgExpandBriefDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerExpand(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerExpandMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerExpand>>
>;
export type WgClientControllerExpandMutationBody = WgExpandBriefDto;
export type WgClientControllerExpandMutationError = void;

/**
 * @summary Write a full brief for one date, without saving it
 */
export const useWgClientControllerExpand = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerExpand>>,
      TError,
      { orgId: string; clientId: string; data: WgExpandBriefDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerExpand>>,
  TError,
  { orgId: string; clientId: string; data: WgExpandBriefDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerExpandMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Answers for the draft in the composer rather than for a saved brief, so the same button works before anything exists and on a brief already on the plan. Pressing it again proposes a different test, because what the brand tested recently is part of the question.
 * @summary Propose the A/B test for a brief, without saving it
 */
export const wgClientControllerProposeAbTest = (
  orgId: string,
  clientId: string,
  wgProposeAbTestDto: WgProposeAbTestDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgAbTestProposalDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/ab-test/propose`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgProposeAbTestDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerProposeAbTestMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>,
    TError,
    { orgId: string; clientId: string; data: WgProposeAbTestDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>,
  TError,
  { orgId: string; clientId: string; data: WgProposeAbTestDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerProposeAbTest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>,
    { orgId: string; clientId: string; data: WgProposeAbTestDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerProposeAbTest(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerProposeAbTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>
>;
export type WgClientControllerProposeAbTestMutationBody = WgProposeAbTestDto;
export type WgClientControllerProposeAbTestMutationError = void;

/**
 * @summary Propose the A/B test for a brief, without saving it
 */
export const useWgClientControllerProposeAbTest = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>,
      TError,
      { orgId: string; clientId: string; data: WgProposeAbTestDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerProposeAbTest>>,
  TError,
  { orgId: string; clientId: string; data: WgProposeAbTestDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerProposeAbTestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Answers for the draft in the composer rather than for a saved brief, so the same button works before anything exists and on a brief already on the plan. A brief written by hand gets the same help as a generated one.
 * @summary Three alternatives for a brief's subject line or preview text
 */
export const wgClientControllerSuggestBriefCopy = (
  orgId: string,
  clientId: string,
  wgSuggestBriefCopyDto: WgSuggestBriefCopyDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgCopySuggestionsDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/suggest-copy`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgSuggestBriefCopyDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerSuggestBriefCopyMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>,
    TError,
    { orgId: string; clientId: string; data: WgSuggestBriefCopyDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>,
  TError,
  { orgId: string; clientId: string; data: WgSuggestBriefCopyDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerSuggestBriefCopy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>,
    { orgId: string; clientId: string; data: WgSuggestBriefCopyDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerSuggestBriefCopy(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerSuggestBriefCopyMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>
>;
export type WgClientControllerSuggestBriefCopyMutationBody = WgSuggestBriefCopyDto;
export type WgClientControllerSuggestBriefCopyMutationError = void;

/**
 * @summary Three alternatives for a brief's subject line or preview text
 */
export const useWgClientControllerSuggestBriefCopy = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>,
      TError,
      { orgId: string; clientId: string; data: WgSuggestBriefCopyDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerSuggestBriefCopy>>,
  TError,
  { orgId: string; clientId: string; data: WgSuggestBriefCopyDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerSuggestBriefCopyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Answers for the draft in the composer rather than for a saved brief, so the same button works before anything exists and on a brief already on the plan. Only the prose comes back: the title, products, images, inbox copy and date stay as the draft has them.
 * @summary A different take on the brief prose, keeping the idea
 */
export const wgClientControllerRewriteBrief = (
  orgId: string,
  clientId: string,
  wgRewriteBriefDto: WgRewriteBriefDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgRewrittenBriefDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/rewrite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgRewriteBriefDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerRewriteBriefMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>,
    TError,
    { orgId: string; clientId: string; data: WgRewriteBriefDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>,
  TError,
  { orgId: string; clientId: string; data: WgRewriteBriefDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerRewriteBrief'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>,
    { orgId: string; clientId: string; data: WgRewriteBriefDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerRewriteBrief(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerRewriteBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>
>;
export type WgClientControllerRewriteBriefMutationBody = WgRewriteBriefDto;
export type WgClientControllerRewriteBriefMutationError = void;

/**
 * @summary A different take on the brief prose, keeping the idea
 */
export const useWgClientControllerRewriteBrief = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>,
      TError,
      { orgId: string; clientId: string; data: WgRewriteBriefDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerRewriteBrief>>,
  TError,
  { orgId: string; clientId: string; data: WgRewriteBriefDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerRewriteBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Opens production work from a customer brief without creating a calendar item or scheduling a send. Once approved, the result remains a reusable template.
 * @summary Create a calendar-free White Glove email
 */
export const wgClientControllerComposeOneOff = (
  orgId: string,
  clientId: string,
  wgComposeOneOffBriefDto: WgComposeOneOffBriefDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgComposeOneOffResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/one-off`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgComposeOneOffBriefDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerComposeOneOffMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>,
    TError,
    { orgId: string; clientId: string; data: WgComposeOneOffBriefDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>,
  TError,
  { orgId: string; clientId: string; data: WgComposeOneOffBriefDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerComposeOneOff'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>,
    { orgId: string; clientId: string; data: WgComposeOneOffBriefDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerComposeOneOff(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerComposeOneOffMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>
>;
export type WgClientControllerComposeOneOffMutationBody = WgComposeOneOffBriefDto;
export type WgClientControllerComposeOneOffMutationError = void;

/**
 * @summary Create a calendar-free White Glove email
 */
export const useWgClientControllerComposeOneOff = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>,
      TError,
      { orgId: string; clientId: string; data: WgComposeOneOffBriefDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerComposeOneOff>>,
  TError,
  { orgId: string; clientId: string; data: WgComposeOneOffBriefDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerComposeOneOffMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cancels its ticket while nobody has started on it; a brief already in production is refused with a 400 and goes through a lead instead.
 * @summary Take a brief off the plan
 */
export const wgClientControllerSkip = (
  orgId: string,
  clientId: string,
  itemId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgBriefCardDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}/skip`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getWgClientControllerSkipMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerSkip>>,
    TError,
    { orgId: string; clientId: string; itemId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerSkip>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationKey = ['wgClientControllerSkip'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerSkip>>,
    { orgId: string; clientId: string; itemId: string }
  > = (props) => {
    const { orgId, clientId, itemId } = props ?? {};

    return wgClientControllerSkip(orgId, clientId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerSkipMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerSkip>>
>;

export type WgClientControllerSkipMutationError = void;

/**
 * @summary Take a brief off the plan
 */
export const useWgClientControllerSkip = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerSkip>>,
      TError,
      { orgId: string; clientId: string; itemId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerSkip>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationOptions = getWgClientControllerSkipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * For a brand that approves briefs before production. Each brief opens its ticket on its own; one that cannot is left waiting and named in failedItemIds rather than failing the rest. A brief already approved is answered as it is, and a skipped one is refused with a 400.
 * @summary Approve several briefs at once, and start production on each
 */
export const wgClientControllerApproveBriefs = (
  orgId: string,
  clientId: string,
  wgApproveBriefsDto: WgApproveBriefsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgApproveBriefsResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/approve`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgApproveBriefsDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerApproveBriefsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>,
    TError,
    { orgId: string; clientId: string; data: WgApproveBriefsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>,
  TError,
  { orgId: string; clientId: string; data: WgApproveBriefsDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerApproveBriefs'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>,
    { orgId: string; clientId: string; data: WgApproveBriefsDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerApproveBriefs(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerApproveBriefsMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>
>;
export type WgClientControllerApproveBriefsMutationBody = WgApproveBriefsDto;
export type WgClientControllerApproveBriefsMutationError = void;

/**
 * @summary Approve several briefs at once, and start production on each
 */
export const useWgClientControllerApproveBriefs = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>,
      TError,
      { orgId: string; clientId: string; data: WgApproveBriefsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerApproveBriefs>>,
  TError,
  { orgId: string; clientId: string; data: WgApproveBriefsDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerApproveBriefsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * For a brand that approves briefs before production. Opens the ticket; approving one already approved answers with the brief as it is, and a skipped one is refused with a 400.
 * @summary Approve a brief and start production on it
 */
export const wgClientControllerApproveBrief = (
  orgId: string,
  clientId: string,
  itemId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgBriefCardDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/briefs/${itemId}/approve`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getWgClientControllerApproveBriefMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerApproveBrief>>,
    TError,
    { orgId: string; clientId: string; itemId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerApproveBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationKey = ['wgClientControllerApproveBrief'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerApproveBrief>>,
    { orgId: string; clientId: string; itemId: string }
  > = (props) => {
    const { orgId, clientId, itemId } = props ?? {};

    return wgClientControllerApproveBrief(orgId, clientId, itemId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerApproveBriefMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerApproveBrief>>
>;

export type WgClientControllerApproveBriefMutationError = void;

/**
 * @summary Approve a brief and start production on it
 */
export const useWgClientControllerApproveBrief = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerApproveBrief>>,
      TError,
      { orgId: string; clientId: string; itemId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerApproveBrief>>,
  TError,
  { orgId: string; clientId: string; itemId: string },
  TContext
> => {
  const mutationOptions = getWgClientControllerApproveBriefMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Never overwrites an existing item and never re-dates one. Every brief it writes opens a ticket straight away, unless the brand approves briefs first, when they wait for approval instead; edit, re-date or skip them from the calendar.
 * @summary Plan only the empty dates in a window
 */
export const wgClientControllerFillGaps = (
  orgId: string,
  clientId: string,
  wgFillGapsDto: WgFillGapsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgFillGapsResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/calendar/fill-gaps`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgFillGapsDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerFillGapsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerFillGaps>>,
    TError,
    { orgId: string; clientId: string; data: WgFillGapsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerFillGaps>>,
  TError,
  { orgId: string; clientId: string; data: WgFillGapsDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerFillGaps'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerFillGaps>>,
    { orgId: string; clientId: string; data: WgFillGapsDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerFillGaps(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerFillGapsMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerFillGaps>>
>;
export type WgClientControllerFillGapsMutationBody = WgFillGapsDto;
export type WgClientControllerFillGapsMutationError = void;

/**
 * @summary Plan only the empty dates in a window
 */
export const useWgClientControllerFillGaps = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerFillGaps>>,
      TError,
      { orgId: string; clientId: string; data: WgFillGapsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerFillGaps>>,
  TError,
  { orgId: string; clientId: string; data: WgFillGapsDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerFillGapsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Derived from the brand's own sending history, list size and unsubscribe rate every time it is read, so the wizard and a later review see the same proposal from the same inputs. Reading it commits to nothing.
 * @summary What the service would commit this brand to, and why
 */
export const wgClientControllerScheduleProposal = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgScheduleProposalDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/schedule/proposal`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getWgClientControllerScheduleProposalQueryKey = (
  orgId?: string,
  clientId?: string
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/schedule/proposal`,
  ] as const;
};

export const getWgClientControllerScheduleProposalQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerScheduleProposalQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>> = ({
    signal,
  }) => wgClientControllerScheduleProposal(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerScheduleProposalQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>
>;
export type WgClientControllerScheduleProposalQueryError = void;

export function useWgClientControllerScheduleProposal<
  TData = Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerScheduleProposal<
  TData = Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerScheduleProposal<
  TData = Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary What the service would commit this brand to, and why
 */

export function useWgClientControllerScheduleProposal<
  TData = Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerScheduleProposal>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerScheduleProposalQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Re-plans the dates that have not been built yet: unbuilt briefs the service wrote are cleared and replaced on the new rhythm, while anything already in production, every anchor, and every brief the customer wrote themselves are left alone. Sending planningMode `nexmail` derives and adopts a schedule and ignores any days or count sent with it.
 * @summary Change the planning mode, the send days, or the monthly count
 */
export const wgClientControllerUpdateSchedule = (
  orgId: string,
  clientId: string,
  wgUpdateScheduleDto: WgUpdateScheduleDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<WgUpdateScheduleResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/schedule`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: wgUpdateScheduleDto,
    },
    options
  );
};

export const getWgClientControllerUpdateScheduleMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>,
    TError,
    { orgId: string; clientId: string; data: WgUpdateScheduleDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>,
  TError,
  { orgId: string; clientId: string; data: WgUpdateScheduleDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerUpdateSchedule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>,
    { orgId: string; clientId: string; data: WgUpdateScheduleDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerUpdateSchedule(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerUpdateScheduleMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>
>;
export type WgClientControllerUpdateScheduleMutationBody = WgUpdateScheduleDto;
export type WgClientControllerUpdateScheduleMutationError = void;

/**
 * @summary Change the planning mode, the send days, or the monthly count
 */
export const useWgClientControllerUpdateSchedule = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>,
      TError,
      { orgId: string; clientId: string; data: WgUpdateScheduleDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerUpdateSchedule>>,
  TError,
  { orgId: string; clientId: string; data: WgUpdateScheduleDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerUpdateScheduleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Runs the same parser the save path runs and hands back what it made of each line, so the customer corrects a misread date while it is still a row rather than after it is an anchor the plan is built around. Lines it cannot read come back verbatim instead of being guessed at.
 * @summary Read a pasted list of dates without committing to any of them
 */
export const wgClientControllerParseCommitmentText = (
  orgId: string,
  clientId: string,
  wgParseCommitmentsDto: WgParseCommitmentsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgParseCommitmentsResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/commitments/parse`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgParseCommitmentsDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerParseCommitmentTextMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>,
    TError,
    { orgId: string; clientId: string; data: WgParseCommitmentsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>,
  TError,
  { orgId: string; clientId: string; data: WgParseCommitmentsDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerParseCommitmentText'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>,
    { orgId: string; clientId: string; data: WgParseCommitmentsDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerParseCommitmentText(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerParseCommitmentTextMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>
>;
export type WgClientControllerParseCommitmentTextMutationBody = WgParseCommitmentsDto;
export type WgClientControllerParseCommitmentTextMutationError = void;

/**
 * @summary Read a pasted list of dates without committing to any of them
 */
export const useWgClientControllerParseCommitmentText = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>,
      TError,
      { orgId: string; clientId: string; data: WgParseCommitmentsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerParseCommitmentText>>,
  TError,
  { orgId: string; clientId: string; data: WgParseCommitmentsDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerParseCommitmentTextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Rows the customer has checked come in as `entries`, a raw paste comes in as `text` and is parsed in the brand's own timezone, and both may be sent together. Each becomes an approved brief with a ticket behind it however far out it is, so the queue knows about work that has been agreed. A row may carry products and images, which is what separates a commitment a producer can start from from a title on a date. Available on every planning mode: telling us about a promotion is not something only a managed brand should be able to do.
 * @summary Add dated things the brand is committed to
 */
export const wgClientControllerAddCommitments = (
  orgId: string,
  clientId: string,
  wgAddCommitmentsDto: WgAddCommitmentsDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgAddCommitmentsResultDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/commitments`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: wgAddCommitmentsDto,
      signal,
    },
    options
  );
};

export const getWgClientControllerAddCommitmentsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerAddCommitments>>,
    TError,
    { orgId: string; clientId: string; data: WgAddCommitmentsDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerAddCommitments>>,
  TError,
  { orgId: string; clientId: string; data: WgAddCommitmentsDto },
  TContext
> => {
  const mutationKey = ['wgClientControllerAddCommitments'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerAddCommitments>>,
    { orgId: string; clientId: string; data: WgAddCommitmentsDto }
  > = (props) => {
    const { orgId, clientId, data } = props ?? {};

    return wgClientControllerAddCommitments(orgId, clientId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerAddCommitmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerAddCommitments>>
>;
export type WgClientControllerAddCommitmentsMutationBody = WgAddCommitmentsDto;
export type WgClientControllerAddCommitmentsMutationError = void;

/**
 * @summary Add dated things the brand is committed to
 */
export const useWgClientControllerAddCommitments = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerAddCommitments>>,
      TError,
      { orgId: string; clientId: string; data: WgAddCommitmentsDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerAddCommitments>>,
  TError,
  { orgId: string; clientId: string; data: WgAddCommitmentsDto },
  TContext
> => {
  const mutationOptions = getWgClientControllerAddCommitmentsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Includes dismissed ones, because a moment somebody turned off is information: without it there is no way to tell a decision from an oversight.
 * @summary Holidays and commercial moments on this brand's calendar
 */
export const wgClientControllerListMoments = (
  orgId: string,
  clientId: string,
  params?: WgClientControllerListMomentsParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgMomentListDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/moments`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getWgClientControllerListMomentsQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: WgClientControllerListMomentsParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/moments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWgClientControllerListMomentsQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerListMoments>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListMomentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListMoments>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerListMomentsQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerListMoments>>> = ({
    signal,
  }) => wgClientControllerListMoments(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerListMoments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerListMomentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerListMoments>>
>;
export type WgClientControllerListMomentsQueryError = void;

export function useWgClientControllerListMoments<
  TData = Awaited<ReturnType<typeof wgClientControllerListMoments>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: undefined | WgClientControllerListMomentsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListMoments>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerListMoments>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerListMoments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerListMoments<
  TData = Awaited<ReturnType<typeof wgClientControllerListMoments>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListMomentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListMoments>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerListMoments>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerListMoments>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerListMoments<
  TData = Awaited<ReturnType<typeof wgClientControllerListMoments>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListMomentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListMoments>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Holidays and commercial moments on this brand's calendar
 */

export function useWgClientControllerListMoments<
  TData = Awaited<ReturnType<typeof wgClientControllerListMoments>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgClientControllerListMomentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerListMoments>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerListMomentsQueryOptions(
    orgId,
    clientId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * What a brand running its own calendar gets instead of briefs: the dates that are about to matter and have nothing near them yet. A moment counts as handled if anything at all sits within a few days of it, whatever it is called.
 * @summary Moments coming up with nothing planned around them
 */
export const wgClientControllerMomentNudges = (
  orgId: string,
  clientId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgMomentListDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/moments/nudges`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getWgClientControllerMomentNudgesQueryKey = (orgId?: string, clientId?: string) => {
  return [`/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/moments/nudges`] as const;
};

export const getWgClientControllerMomentNudgesQueryOptions = <
  TData = Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgClientControllerMomentNudgesQueryKey(orgId, clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>> = ({
    signal,
  }) => wgClientControllerMomentNudges(orgId, clientId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgClientControllerMomentNudgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerMomentNudges>>
>;
export type WgClientControllerMomentNudgesQueryError = void;

export function useWgClientControllerMomentNudges<
  TData = Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerMomentNudges>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerMomentNudges<
  TData = Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
          TError,
          Awaited<ReturnType<typeof wgClientControllerMomentNudges>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgClientControllerMomentNudges<
  TData = Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Moments coming up with nothing planned around them
 */

export function useWgClientControllerMomentNudges<
  TData = Awaited<ReturnType<typeof wgClientControllerMomentNudges>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgClientControllerMomentNudges>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgClientControllerMomentNudgesQueryOptions(orgId, clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Permanent: the moment is never re-proposed for that year. Briefs it already planted stay where they are, because cancelling work that may be underway is a separate decision made per brief.
 * @summary Turn a moment off for this brand
 */
export const wgClientControllerDismissMoment = (
  orgId: string,
  clientId: string,
  momentKey: string,
  year: number,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgMomentListDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/moments/${momentKey}/${year}/dismiss`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getWgClientControllerDismissMomentMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof wgClientControllerDismissMoment>>,
    TError,
    { orgId: string; clientId: string; momentKey: string; year: number },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof wgClientControllerDismissMoment>>,
  TError,
  { orgId: string; clientId: string; momentKey: string; year: number },
  TContext
> => {
  const mutationKey = ['wgClientControllerDismissMoment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof wgClientControllerDismissMoment>>,
    { orgId: string; clientId: string; momentKey: string; year: number }
  > = (props) => {
    const { orgId, clientId, momentKey, year } = props ?? {};

    return wgClientControllerDismissMoment(orgId, clientId, momentKey, year, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type WgClientControllerDismissMomentMutationResult = NonNullable<
  Awaited<ReturnType<typeof wgClientControllerDismissMoment>>
>;

export type WgClientControllerDismissMomentMutationError = void;

/**
 * @summary Turn a moment off for this brand
 */
export const useWgClientControllerDismissMoment = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof wgClientControllerDismissMoment>>,
      TError,
      { orgId: string; clientId: string; momentKey: string; year: number },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof wgClientControllerDismissMoment>>,
  TError,
  { orgId: string; clientId: string; momentKey: string; year: number },
  TContext
> => {
  const mutationOptions = getWgClientControllerDismissMomentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Read from the materialized per-ticket metrics rather than computed from the event log, so a ninety-day view costs the same as a thirty-day one.
 * @summary Service health for the period, every figure with its definition
 */
export const wgHealthControllerHealth = (
  orgId: string,
  clientId: string,
  params?: WgHealthControllerHealthParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WgServiceHealthDto>(
    {
      url: `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/health`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getWgHealthControllerHealthQueryKey = (
  orgId?: string,
  clientId?: string,
  params?: WgHealthControllerHealthParams
) => {
  return [
    `/api/v1/organizations/${orgId}/clients/${clientId}/white-glove/health`,
    ...(params ? [params] : []),
  ] as const;
};

export const getWgHealthControllerHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof wgHealthControllerHealth>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgHealthControllerHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgHealthControllerHealth>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWgHealthControllerHealthQueryKey(orgId, clientId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof wgHealthControllerHealth>>> = ({
    signal,
  }) => wgHealthControllerHealth(orgId, clientId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(orgId && clientId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof wgHealthControllerHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WgHealthControllerHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof wgHealthControllerHealth>>
>;
export type WgHealthControllerHealthQueryError = void;

export function useWgHealthControllerHealth<
  TData = Awaited<ReturnType<typeof wgHealthControllerHealth>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params: undefined | WgHealthControllerHealthParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgHealthControllerHealth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgHealthControllerHealth>>,
          TError,
          Awaited<ReturnType<typeof wgHealthControllerHealth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgHealthControllerHealth<
  TData = Awaited<ReturnType<typeof wgHealthControllerHealth>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgHealthControllerHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgHealthControllerHealth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof wgHealthControllerHealth>>,
          TError,
          Awaited<ReturnType<typeof wgHealthControllerHealth>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWgHealthControllerHealth<
  TData = Awaited<ReturnType<typeof wgHealthControllerHealth>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgHealthControllerHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgHealthControllerHealth>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Service health for the period, every figure with its definition
 */

export function useWgHealthControllerHealth<
  TData = Awaited<ReturnType<typeof wgHealthControllerHealth>>,
  TError = void,
>(
  orgId: string,
  clientId: string,
  params?: WgHealthControllerHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof wgHealthControllerHealth>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getWgHealthControllerHealthQueryOptions(orgId, clientId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
